import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

import imgClassica1 from '../components/Classico1.jpg';
import imgClassica2 from '../components/Classico2.jpg';
import imgPresente from '../components/Presente.jpg';

import imgAlquimia1 from '../components/Alquimia1.jpg';
import imgAlquimia2 from '../components/Alquimia2.jpg';
import imgAlquimiaPresente from '../components/PresenteAlquimia.jpg';

import imgLinho1 from '../components/Linho1.jpg';
import imgLinho2 from '../components/Linho2.jpg';
import imgLinho3 from '../components/Linho3.jpg';
import imgLinho4 from '../components/Linho4.jpg';

import imgRecarga1 from '../components/Recarga1.jpg';
import imgRecarga2 from '../components/Recarga2.jpg';
import imgRecarga3 from '../components/Recarga3.jpg';

import imgLotus1 from '../components/Lotus1.jpg';
import imgLotus2 from '../components/Lotus2.jpg';
import imgLotus3 from '../components/Lotus3.jpg';
import imgLotus4 from '../components/Lotus4.jpg';
import imgLotus5 from '../components/Lotus5.jpg';

import imgAromaSleep from '../components/AromaSleep.jpg';
import imgAromaCoffee from '../components/AromaCoffeeBreak.png';
import imgAromaFloral from '../components/AromaFloral.jpg';
import imgAromaBaunilha from '../components/AromaBaunilha.jpg';
import imgAromaSpicy from '../components/AromaSpicy.jpg';
import imgAromaTreat from '../components/AromaTreat.png';
import imgAromaTropical from '../components/AromaTropical.jpg';
import imgAromaWatermelon from '../components/AromaWatermelon.png';

const SingleProduct = () => {
  const { productName } = useParams();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedScent, setSelectedScent] = useState('');
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  // Ensure page starts from top
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [productName]);
 
  const products = {
    classico: {
      name: 'Clássico',
      description: 'Uma vela que celebra a tradição e elegância atemporal. Feita com cera 100% soja em copo de vidro branco matte e pavio de madeira',
      fullDescription: <p><br/><b><i>*Caixa Presente</i></b>: <br/>caixa kraft com papel seda branco, uma etiqueta kraft e fio de sisal em laço<br/><br/> <b><i>Detalhes</i></b>: <br/> <b>Tamanho</b>: 6.85 x 8.35 x 6.70 cm <br/> <b>Tempo de queima</b>: 45 horas <br/> <b>Ingredientes</b>: cera de soja, pavio de madeira, adesivo, suporte metálico, fragrância <br/> <b>Advertências</b>: não ingerir; manter fora do alcançe de crianças e animais; não deixar a vela sem supervisão; não toques ou movas a vela durante a queima; <br/> <b>Modo de Usar</b>: Acende a vela e desfruta do aroma <br/> <b>Origem</b>: Portugal <br/> <b>Reciclagem</b>: Coloca a caixa de cartão no ecoponto azul ou reutiliza. O copo pode ser reutilizado ou coloca no ecoponto verde. </p>,
      price: '15.00 €',
      images: [
        imgClassica1,
        imgClassica2,
        imgPresente,
      ],
      scents: [
        {
          name: 'Coffee Break',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> doce, cremoso, coco<br/><b>Notas de corpo:</b> floral, frutado, amanteigado<br/><b>Notas de base:</b> almíscar, baunilha, caramelo</p>,
          selected: ' Saboreia-o agora',
          botanicalImage: imgAromaCoffee
        }
      ],
      bgGradient: 'from-[#F5E6D3] to-[#E8D5C4]'
    },
    alquimia: {
      name: 'Alquimia',
      description: 'Uma vela que transforma cera em magia. Feita com cera 100% soja em frasco âmbar, pavio de madeira e brilho',
      fullDescription: <p><br/><b><i>*Caixa Presente</i></b>: <br/>caixa kraft com papel seda branco, uma etiqueta kraft e fio de sisal em laço<br/><br/> <b><i>Detalhes</i></b>: <br/> <b>Tamanho</b>: 6.51 x 8.20 x 6.49 cm <br/> <b>Tempo de queima</b>: 40 horas <br/> <b>Ingredientes</b>: cera de soja, pavio de madeira, adesivo, suporte metálico, mica, fragrância <br/> <b>Advertências</b>: não ingerir; manter fora do alcançe de crianças e animais; não deixar a vela sem supervisão; não toques ou movas a vela durante a queima; <br/> <b>Modo de Usar</b>: Acende a vela e desfruta do aroma <br/> <b>Origem</b>: Portugal <br/> <b>Reciclagem</b>: Coloca a caixa de cartão no ecoponto azul ou reutiliza. O frasco pode ser reutilizado ou coloca no ecoponto verde. </p>,
      price: '14.00 €',
      images: [
        imgAlquimia2,
        imgAlquimia1,
        imgAlquimiaPresente
      ],
      scents: [
        {
          name: 'Spicy Raspberry',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> framboesa, pimenta preta e rosa, rosa<br/><b>Notas de corpo:</b>  flores brancas, jasmim, vetiver<br/><b>Notas de base:</b> almíscar, âmbar</p>,
          selected: 'Elegância com um toque de ousadia',
          botanicalImage: imgAromaSpicy
        },
        {
          name: 'Luxurious Vanilla',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> coco, notas florais<br/><b>Notas de corpo:</b> açúcar, manteiga de cacau, baunilha<br/><b>Notas de base:</b> baunilha, âmbar, almíscar</p>,
          selected: 'Conforto em cada nota',
          botanicalImage: imgAromaBaunilha
        }
      ],
      bgGradient: 'from-[#E8D5C4] to-[#D4C5B0]'
    },
    linho: {
      name: 'Linho',
      description: 'Uma vela que evoca o luxo e a suavidade do linho. Feita em copo de gesso cerâmico, com ou sem tampa e pavio de madeira.',
      fullDescription: <p><br/><b><i>*Caixa Presente</i></b>: <br/>caixa kraft com papel seda branco, uma etiqueta kraft e fio de sisal em laço<br/> <br/><b><i>Tampa</i></b>: <br/>A tampa é opcional, com o custo acrescido de 1€<br/><br/> <b><i>Detalhes</i></b>: <br/> <b>Tamanho</b>: 7.51 x 7.57 x 7.51 cm <br/> <b>Tempo de queima</b>: 45 horas <br/> <b>Ingredientes</b>: cera de soja, pavio de madeira, adesivo, suporte metálico, fragrância <br/> <b>Advertências</b>: não ingerir; manter fora do alcançe de crianças e animais; não deixar a vela sem supervisão; não toques ou movas a vela durante a queima; <br/> <b>Modo de Usar</b>: Acende a vela e desfruta do aroma <br/> <b>Origem</b>: Portugal <br/> <b>Reciclagem</b>: Coloca a caixa de cartão no ecoponto azul ou reutiliza. O copo pode ser reutilizado recarregando com uma nova vela ou para colocar novos objectos. </p>,
      price: '19.00 €',
      images: [
        imgLinho1,
        imgLinho2,
        imgLinho3,
        imgLinho4
      ],
      scents: [
        {
          name: 'Sleep in the Clouds',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b>  limão, laranja, bergamota, eucalipto, cânfora<br/><b>Notas de corpo:</b> cravo, lavanda<br/><b>Notas de base:</b> baunilha, almíscar, tonka, açúcar</p>,
          selected: 'Aroma que acalma',
          botanicalImage: imgAromaSleep
        },
        {
          name: 'Floral Symphony',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> rosa da Bulgária, peónia<br/><b>Notas de corpo:</b> cravo, âmbar, noz, leite<br/><b>Notas de base:</b> baunilha, praliné, madeira de agar (Oud)</p>,
          selected: 'Uma dança perfumada no final do dia',
          botanicalImage: imgAromaFloral
        },
        {
          name: 'Luxurious Vanilla',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> coco, notas florais<br/><b>Notas de corpo:</b> açúcar, manteiga de cacau, baunilha<br/><b>Notas de base:</b> baunilha, âmbar, almíscar</p>,
          selected: 'Conforto em cada nota',
          botanicalImage: imgAromaBaunilha
        }
      ],
      bgGradient: 'from-[#FEFEFE] to-[#F5F5F5]'
    },
    charcoal: {
      name: 'Recargas',
      description: 'A tua vela acabou? Tens oportunidade de a recarregar com a tua fragrância favorita.',
      fullDescription: <p><br/><b><i>*Caixa Presente</i></b>: <br/>caixa kraft com papel seda branco, uma etiqueta kraft e fio de sisal em laço<br/><br/> <b><i>Detalhes</i></b>: <br/> <b>Tamanho</b>: 6.11 x 5.65 x 6.22 cm <br/> <b>Tempo de queima</b>: 45 horas <br/> <b>Ingredientes</b>: cera de soja, pavio de madeira, adesivo, suporte metálico, fragrância <br/> <b>Advertências</b>: não ingerir; manter fora do alcançe de crianças e animais; não deixar a vela sem supervisão; não toques ou movas a vela durante a queima; <br/> <b>Modo de Usar</b>: Limpa cuidadosamente o copo Linho e coloca a nova recarga. Acende a vela e desfruta do seu aroma <br/> <b>Origem</b>: Portugal <br/> <b>Reciclagem</b>: Coloca a caixa de cartão no ecoponto azul ou reutiliza. </p>,
      price: '9.50 €',
      images: [
        imgRecarga1,
        imgRecarga2,
        imgRecarga3
      ],
      scents: [
        {
          name: 'Sleep in the Clouds',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b>  limão, laranja, bergamota, eucalipto, cânfora<br/><b>Notas de corpo:</b> cravo, lavanda<br/><b>Notas de base:</b> baunilha, almíscar, tonka, açúcar</p>,
          selected: 'Aroma que acalma',
          botanicalImage: imgAromaSleep
        },
        {
          name: 'Floral Symphony',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> rosa da Bulgária, peónia<br/><b>Notas de corpo:</b> cravo, âmbar, noz, leite<br/><b>Notas de base:</b> baunilha, praliné, madeira de agar (Oud)</p>,
          selected: 'Uma dança perfumada no final do dia',
          botanicalImage: imgAromaFloral
        },
        {
          name: 'Luxurious Vanilla',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> coco, notas florais<br/><b>Notas de corpo:</b> açúcar, manteiga de cacau, baunilha<br/><b>Notas de base:</b> baunilha, âmbar, almíscar</p>,
          selected: 'Conforto em cada nota',
          botanicalImage: imgAromaBaunilha
        }
      ],
      bgGradient: 'from-[#F5F5F5] to-[#E8E8E8]'
    },
    lotus: {
      name: 'Lotus',
      description: 'A vela inspirada na alma da marca. Feita em copo de gesso cerâmico e pavio de madeira.',
      fullDescription: <p><br/><b><i>*Caixa Presente</i></b>: <br/>caixa kraft com papel seda branco, uma etiqueta kraft e fio de sisal em laço<br/><br/> <b><i>Detalhes</i></b>: <br/> <b>Tamanho</b>: 8.20 x 4.20 cm <br/> <b>Tempo de queima</b>: 15 horas <br/> <b>Ingredientes</b>: cera de soja, pavio de madeira, adesivo, suporte metálico, fragrância <br/> <b>Advertências</b>: não ingerir; manter fora do alcançe de crianças e animais; não deixar a vela sem supervisão; não toques ou movas a vela durante a queima; <br/> <b>Modo de Usar</b>: Acende a vela e desfruta do seu aroma <br/> <b>Origem</b>: Portugal <br/> <b>Reciclagem</b>: Coloca a caixa de cartão no ecoponto azul ou reutiliza. O copo pode ser reutilizado para colocar novos objectos. </p>,
      price: '7.50 €',
      images: [
        imgLotus5,
        imgLotus2,
        imgLotus3,
        imgLotus4
      ],
      scents: [
        {
          name: 'Sleep in the Clouds',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b>  limão, laranja, bergamota, eucalipto, cânfora<br/><b>Notas de corpo:</b> cravo, lavanda<br/><b>Notas de base:</b> baunilha, almíscar, tonka, açúcar</p>,
          selected: 'Aroma que acalma',
          botanicalImage: imgAromaSleep
        },
        {
          name: 'Floral Symphony',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> rosa da Bulgária, peónia<br/><b>Notas de corpo:</b> cravo, âmbar, noz, leite<br/><b>Notas de base:</b> baunilha, praliné, madeira de agar (Oud)</p>,
          selected: 'Uma dança perfumada no final do dia',
          botanicalImage: imgAromaFloral
        },
        {
          name: 'Luxurious Vanilla',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> coco, notas florais<br/><b>Notas de corpo:</b> açúcar, manteiga de cacau, baunilha<br/><b>Notas de base:</b> baunilha, âmbar, almíscar</p>,
          selected: 'Conforto em cada nota',
          botanicalImage: imgAromaBaunilha
        },
        {
          name: 'Spicy Raspberry',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> framboesa, pimenta preta e rosa, rosa<br/><b>Notas de corpo:</b>  flores brancas, jasmim, vetiver<br/><b>Notas de base:</b> almíscar, âmbar</p>,
          selected: 'Elegância com um toque de ousadia',
          botanicalImage: imgAromaSpicy
        },
        {
          name: 'Coffee Break',
          description: <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed"><b>Notas de topo:</b> doce, cremoso, coco<br/><b>Notas de corpo:</b> floral, frutado, amanteigado<br/><b>Notas de base:</b> almíscar, baunilha, caramelo</p>,
          selected: ' Saboreia-o agora',
          botanicalImage: imgAromaCoffee
        }
      ],
      bgGradient: 'from-[#F5F5F5] to-[#E8E8E8]'
    }
  };

  const currentProduct = products[productName] || products.classico;

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % currentProduct.images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + currentProduct.images.length) % currentProduct.images.length);
  };

  const selectImage = (index) => {
    setCurrentImageIndex(index);
  };

  const toggleDescription = () => {
    setIsDescriptionExpanded(!isDescriptionExpanded);
  };

  // Get first paragraph from description
  const getFirstParagraph = (text) => {
    return text.split()[0];
  };

  return (
    <div className={`min-h-screen bg-pure_fundo`}>
      <Header />
      
      {/* Product Hero */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            
            {/* Image Gallery */}
            <div className="space-y-6">
              {/* Main Image */}
              <div className="relative aspect-square bg-pure_fundo rounded-3xl shadow-2xl overflow-hidden">
                <img 
                  src={currentProduct.images[currentImageIndex]}
                  alt={`${currentProduct.name} - Imagem ${currentImageIndex + 1}`}
                  className="w-full h-full object-cover"
                />
                
                {/* Navigation Arrows */}
                <button 
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 backdrop-blur-sm rounded-full p-3 hover:bg-opacity-100 transition-all duration-300 shadow-lg"
                >
                  <svg className="w-6 h-6 text-[#8B4513]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                
                <button 
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 backdrop-blur-sm rounded-full p-3 hover:bg-opacity-100 transition-all duration-300 shadow-lg"
                >
                  <svg className="w-6 h-6 text-[#8B4513]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>

                {/* Image Indicators */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {currentProduct.images.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => selectImage(index)}
                      className={`w-3 h-3 rounded-full transition-all duration-300 ${
                        index === currentImageIndex ? 'bg-[#8B4513]' : 'bg-white bg-opacity-50'
                      }`}
                    />
                  ))}
                </div>
              </div>

              {/* Thumbnail Images */}
              <div className="grid grid-cols-4 gap-4">
                {currentProduct.images.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => selectImage(index)}
                    className={`aspect-square rounded-xl overflow-hidden transition-all duration-300 ${
                      index === currentImageIndex 
                        ? 'ring-4 ring-[#8B4513] shadow-lg' 
                        : 'hover:ring-2 ring-[#A0522D] hover:shadow-md'
                    }`}
                  >
                    <img 
                      src={image}
                      alt={`${currentProduct.name} thumbnail ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div className="space-y-8">
              <div>
                <h1 className="text-5xl md:text-6xl font-lora text-pure_titulo mb-6">
                  {currentProduct.name}
                </h1>
                <p className="text-base leading-relaxed mb-8 font-montserrat text-pure_btn1_txt">
                  {currentProduct.description}
                </p>
                <div className="text-3xl text-pure_btn1_txt font-montserrat leading-relaxed mb-1 mt-8">
                  {currentProduct.price}
                </div>
                <div className="text-sm text-pure_btn1_txt font-montserrat leading-relaxed mb-4 mt-1">
                  (IVA Incluído)
                </div>
                <div className="text-sm text-pure_btn1_txt font-montserrat mb-5 mt-5 border-1 border-solid">
                  *Caixa Presente +1€ 
                </div>

                

                {/* Expandable Description */}
                <div className="mb-8">
                  
                  {/* Expand/Collapse Button */}
                  <button onClick={toggleDescription} className="flex items-center space-x-2 mt-4 font-montserrat text-pure_btn1_txt group">
                    <span className="font-medium">
                      {isDescriptionExpanded ? 'Menos informações' : 'Mais informações'}
                    </span>
                    <svg className={`w-5 h-5 transition-transform duration-300 ${isDescriptionExpanded ? 'rotate-180' : 'rotate-0'} group-hover:scale-110`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  {/* <p>{currentProduct.fullDescription}</p> 
                  {document.querySelector('fullhtml').innerHTML = currentProduct.fullDescription}
                  
                  */}
                  <div className={`text-base leading-relaxed mb-8 font-montserrat text-pure_btn1_txt transition-all duration-500 ease-in-out overflow-hidden ${isDescriptionExpanded ? 'max-h-full visible' : 'max-h-5 collapse'}`}>
                    {currentProduct.fullDescription}
                  </div>
                  
                  

                </div>


              </div>

              {/* Instagram CTA */}
              <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8">  
                <a
                  href="https://instagram.com/pure.pt_"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-pure_gray bg-opacity-20 font-montserrat text-pure_btn1_txt py-3 px-6 rounded-full font-semibold transition-all duration-300 hover:scale-105 shadow-lg flex items-center justify-center space-x-2"
                
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                  <span>Encomenda no Instagram</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Scents Section */}
      <section className="py-24 bg-white bg-opacity-60 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-lora text-pure_titulo mb-6">
              Aromas Disponíveis
            </h2>
            <p className="text-lg max-w-3xl mx-auto leading-relaxed font-montserrat text-pure_btn1_txt">
              Escolhe entre a nossa seleção de fragrâncias cuidadosamente elaboradas, a que combina com o teu momento
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {currentProduct.scents.map((scent, index) => (
              <div 
                key={scent.name}
                onClick={() => setSelectedScent(scent.name)}
                className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer ${
                  selectedScent === scent.name ? 'ring-4 ring-[#8B4513] transform scale-105' : 'hover:scale-102'
                }`}
              >
                <div className="flex items-start space-x-6">
                  {/* Botanical Illustration */}
                  <div className="flex-shrink-0">
                    <div className="w-20 h-20 rounded-full overflow-hidden p-1">
                      <img 
                        src={scent.botanicalImage}
                        alt={`${scent.name} botanical illustration`}
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>
                  </div>
                  
                  {/* Scent Details */}
                  <div className="flex-1">
                    <h3 className="text-2xl font-lora text-pure_titulo mb-3">
                      {scent.name}
                    </h3>
                    <p className="text-sm font-montserrat text-pure_btn1_txt leading-relaxed">
                      {scent.description}
                    </p>
                    
                    {selectedScent === scent.name && (
                      <div className="mt-4 flex items-center text-[#8B4513] font-semibold" style={{ fontFamily: 'The Seasons, serif' }}>
                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        {scent.selected}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SingleProduct;